export interface ResearchCoverage {
  platform: string;
  lastScraped?: string | null;
}

export const RESEARCH_REVIEW_DAYS = 7;
export const canScanSponsors = (platform: string) => ['youtube', 'instagram'].includes(platform.toLowerCase());

/** last_scraped records a save, not a guarantee that all recent posts were analyzed. */
export function researchFreshness(coverage: ResearchCoverage[], now = Date.now()) {
  const supported = coverage.filter(c => canScanSponsors(c.platform));
  if (!supported.length) return { state:'profile-only' as const, savedAt:null };
  const dates = supported.map(c => c.lastScraped ? Date.parse(c.lastScraped) : NaN);
  // Missing coverage on one platform must never be concealed by another's recent save.
  if (dates.some(date => !Number.isFinite(date) || date > now + 300_000)) {
    return { state:'unknown' as const, savedAt:null };
  }
  const oldest = Math.min(...dates);
  return {
    state: now - oldest >= RESEARCH_REVIEW_DAYS * 86_400_000 ? 'aging' as const : 'saved' as const,
    savedAt:new Date(oldest).toISOString(),
  };
}

/** The date as a stamp writes it: month/day in the viewer's zone, empty when there is none. */
export function shortDate(iso: string | null | undefined) {
  if (!iso) return '';
  const date = new Date(iso);
  return Number.isFinite(date.getTime()) ? `${date.getMonth() + 1}/${date.getDate()}` : '';
}
